<template>
    <v-card>
        <v-row cols="12" class="pa-2">
            <v-col cols="3" class="pt-4">
                <v-text-field v-model="search" label="Search in change requests" single-line hide-details dense prepend-icon="mdi-magnify"></v-text-field>
            </v-col>
            <v-col cols="1" class="pt-4">
            </v-col>
            <v-col cols="4" class="pa-0">
                <v-card-title class="justify-center">Overview of completed change requests</v-card-title>
            </v-col>
            <v-col cols="3" class="pt-4">
                <btn_component type="text" text="All"       :color="colorAll"       tooltip="All pending changes" size="x-small" data="All"       @actionClick="selectView"/>
                <btn_component type="text" text="Approved"  :color="colorApproved"  tooltip="Approved changes"    size="x-small" data="Accepted"  @actionClick="selectView"/>
                <btn_component type="text" text="Declined"  :color="colorDeclined"  tooltip="Declined changes"    size="x-small" data="Declined"  @actionClick="selectView"/>
                <btn_component type="text" text="Automatic" :color="colorAutomatic" tooltip="Automatic changes"   size="x-small" data="Automatic" @actionClick="selectView"/>
                <btn_component type="text" text="Manual"    :color="colorManual"    tooltip="Manual changes"      size="x-small" data="Manual"    @actionClick="selectView"/>
            </v-col>
            <v-col cols="1" class="pt-4">
                <btn_component class="pl-16" type="avatar_icon" icon="mdi-close" color="error" tooltip="close audit" size="default" data="" @actionClick="closeAudit"/>
            </v-col>
        </v-row>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    
    export default {
        components: {
            btn_component,
        },
        props: {
            filter: {
                type: String,
                required: true
            }
        }, 
        data() {
            return {
                search: "",
                selected: [],
                selection: "All",
                colorAll: "primary",
                colorApproved: "grey",
                colorDeclined: "grey",
                colorAutomatic: "grey",
                colorManual: "grey",
            }
        },    
        watch: {
            search(newValue) {
                this.$emit("updateSearch", newValue);
            }
        },
        methods: {  
            selectView(newView) {
                this.selection = [];
                if (newView === "All") {
                    this.colorAll = "primary";
                    this.colorApproved = "grey";
                    this.colorDeclined = "grey";
                    this.colorAutomatic = "grey";
                    this.colorManual = "grey";
                    this.selection = ["All"];              
                } else {
                    this.colorAll = "grey";
                }
                if (newView === "Accepted") {
                    this.colorApproved = this.colorApproved === "grey" ? "primary" : "grey";
                }
                if (newView === "Declined") {
                    this.colorDeclined = this.colorDeclined === "grey" ? "primary" : "grey";
                }
                if (newView === "Automatic") {
                    this.colorAutomatic = this.colorAutomatic === "grey" ? "primary" : "grey";
                }
                if (newView === "Manual") {
                    this.colorManual = this.colorManual === "grey" ? "primary" : "grey";
                }
                if ((this.colorApproved === "grey")&&(this.colorDeclined === "grey")&&(this.colorAutomatic === "grey")&&(this.colorManual === "grey")) {
                    this.colorAll = "primary";
                    this.selection = ["All"];
                }
                if (this.selection.length === 0) {
                    if (this.colorApproved === "primary") {
                        this.selection.push("Accepted");
                    }
                    if (this.colorDeclined === "primary") {
                        this.selection.push("Declined");
                    }
                    if (this.colorAutomatic === "primary") {
                        this.selection.push("Automatic");
                    }
                    if (this.colorManual === "primary") {
                        this.selection.push("Manual");
                    }
                }
                this.$emit("updateView", this.selection);
            },  
            updateSelection(newValue) {
                this.selected = newValue;
            },
            closeAudit() {
                this.$router.push({ path: "/wzvz/wzvz_cs_overview/" + this.filter});
            },
        }
    }
</script>

<style scoped> 

</style>